import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { SettingsService } from '../../settings/settings.service';
import { User } from '../../authentication/auth.models';
import { isAdminUser } from '../../utils';

/**
 * Renders its content only for users the server's IsAdminUser check would let through
 * (Django staff, or the admin role). Use it for entry points into admin-only endpoints,
 * where anyone else would get a 403: nothing is rendered at all, rather than a disabled
 * control hinting at an action the user can never take.
 */
@Directive({
  selector: '[appIsAdminUser]',
  standalone: false,
})
export class IsAdminUserDirective implements OnInit, OnDestroy {
  private _subscription: Subscription = new Subscription();

  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private _settingsService: SettingsService
  ) {}

  ngOnInit(): void {
    // The profile is seeded from localStorage and refreshed on login, so re-evaluate
    // whenever it changes instead of reading it once.
    this._subscription.add(
      this._settingsService.currentUser$.subscribe((user: User | null) => this._updateView(isAdminUser(user)))
    );
  }

  private _updateView(isAdmin: boolean): void {
    if (isAdmin) {
      if (this._viewContainer.length === 0) {
        this._viewContainer.createEmbeddedView(this._templateRef);
      }

      return;
    }

    this._viewContainer.clear();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
